import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import uniqueId from 'lodash.uniqueid';
import {getCriteria, setAccountManager, setPill, setSearchId} from 'src/components/criteria-strip/services/criteria-strip-slice';
import {SEARCH_RESULT_TABS} from 'src/constants';

import {isNumberQuery} from '../utils';

import type {UserShortInfo} from 'src/openapi/admin/models/UserShortInfo';

type ShowMoreHookProps = {
    query: string,
    onAfterNavigate: () => void,
    onlyMyAccounts: boolean,
    userShortInfo: UserShortInfo | null,
};

export const useGeneralSearchShowMore = ({
    query,
    onAfterNavigate,
    onlyMyAccounts,
    userShortInfo,
}: ShowMoreHookProps) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return useCallback((searchType: 'ACCOUNT' | 'USER') => {
        const newSearchId = uniqueId('general-search-');
        const isAccount = searchType === 'ACCOUNT';
        const tab = isAccount ? SEARCH_RESULT_TABS.ACCOUNTS : SEARCH_RESULT_TABS.USERS;

        let propName: 'accountNames' | 'userIds' | 'userEmails' = 'userEmails';

        if (isAccount) {
            propName = 'accountNames';
        } else if (isNumberQuery(query)) {
            propName = 'userIds';
        }

        dispatch(setSearchId(newSearchId));
        dispatch(getCriteria(newSearchId));
        dispatch(setPill({propName, pill: [{value: query.trim()}]}));

        if (onlyMyAccounts && userShortInfo) {
            const manager = {
                id: userShortInfo.userId,
                fullName: `${userShortInfo.firstName} ${userShortInfo.lastName}`.trim(),
                email: userShortInfo.email,
            };
            dispatch(setAccountManager(manager));
            dispatch(setPill({propName: 'accountManagerId', pill: {value: userShortInfo.userId}}));
        }

        navigate(`/search-result/${newSearchId}/${tab}`);
        onAfterNavigate();
    }, [dispatch, query, navigate, onAfterNavigate, onlyMyAccounts, userShortInfo]);
};
